export const STORAGE_KEY = "style-on-store";
export const ROOT_URL =
  // "http://localhost:3000/api";
  "https://styleon-backend.herokuapp.com/api";
export const CLIENT_ID = "123456";
export const CLIENT_SECRET = "siddzfortesting";
export const GUEST_CREDENTIALS = {
  username: "guest1234",
  password: "Guest@123",
};
